export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8202.373232d2.jpg";